import { memo, useCallback, useEffect } from 'react';

import { isClanPreloaded } from '~/helpers/clan';
import { closeAllDialogs } from '~/helpers/dialogs';
import useTargetClanId from '~/hooks/useTargetClanId';
import { useAppDispatch, useAppSelector } from '~/store';
import { clanSelector } from '~/store/selectors/clanSelectors';
import { currentClanIdSelector } from '~/store/selectors/currentAccountSelector';
import { fetchClan, fetchMembers } from '~/Actions/ActionClanProfile';

import ClanProfileContent from './ClanProfileContent';
import ClanProfileMessageDisbanded from './ClanProfileMessageDisbanded';
import ClanProfileMessageError from './ClanProfileMessageError';

const ClanProfile = () => {
  const dispatch = useAppDispatch();

  const currentClanId = useAppSelector(currentClanIdSelector);
  const { clanId, isOwnClanBase } = useTargetClanId(currentClanId);

  const clan = useAppSelector((state) => {
    return clanId ? clanSelector(state, clanId) : null;
  });

  const fetchData = useCallback(() => {
    if (!clanId) {
      return;
    }

    void dispatch(fetchClan(clanId));
    void dispatch(fetchMembers(clanId));
  }, [dispatch, clanId]);

  useEffect(() => {
    fetchData();

    return () => {
      dispatch(closeAllDialogs());
    };
  }, [dispatch, fetchData]);

  if (!clan || isClanPreloaded(clan)) {
    return null;
  }

  if ('error' in clan && typeof clan.error === 'string') {
    return <ClanProfileMessageError error={clan.error} onReloadClick={fetchData} />;
  }

  if (clan.isDisbanded) {
    return <ClanProfileMessageDisbanded clan={clan} />;
  }

  return <ClanProfileContent clan={clan} isOwnClanBase={isOwnClanBase} />;
};

export default memo(ClanProfile);
